var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{class:`c-list-action-feedback ${_vm.type}`},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('button',{on:{"click":_vm.onClose}},[_c('img',{attrs:{"src":"/icons/x.svg"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }